import { toast } from "react-toastify";

const ShowError = () => {
  return toast.error("please fill all the required fields after press next button");
};

export default ShowError;